import Swiper, { Keyboard, Navigation, Scrollbar, Pagination, Thumbs } from 'swiper';
import 'swiper/css/thumbs';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default ({
    id,
    loop,
    scrollable,
    thumbnailsId,
    showThumbnails,
    navigationType,
    showNavigation,
    showPagination,
    thumbnailsPerView,
    mobileThumbnailsPerView,
    enableKeyboardNavigation,
}) => ({
    swiper: null,
    thumbnailsSwiper: null,

    init() {
        const swiperElement = document.getElementById(id);
        const options = { loop, spaceBetween: 20 };
        const modules = [];

        if (showThumbnails && thumbnailsId) {
            const thumbnailsElement = document.getElementById(thumbnailsId);
            this.thumbnailsSwiper = new Swiper(thumbnailsElement, {
                slidesPerView: thumbnailsPerView,
                spaceBetween: 10,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                freeMode: true,
                breakpoints: {
                    0: {
                        slidesPerView: mobileThumbnailsPerView,
                    },
                    769: {
                        slidesPerView: thumbnailsPerView,
                    },
                },
            });

            options.thumbs = {
                swiper: this.thumbnailsSwiper,
            };

            modules.push(Thumbs);
        }

        if (enableKeyboardNavigation) {
            options.keyboard = { enabled: true, onlyInViewport: true };
            modules.push(Keyboard);
        }

        if (showNavigation) {
            options.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };
            modules.push(Navigation);
        }

        if (showPagination) {
            options.pagination = {
                el: '.swiper-pagination',
                type: navigationType,
            };
            modules.push(Pagination);
        }

        if (scrollable) {
            options.scrollbar = {
                el: '.swiper-scrollbar',
                draggable: true,
            };
            modules.push(Scrollbar);
        }

        if (modules.length) {
            options.modules = modules;
        }

        this.swiper = new Swiper(swiperElement, options);
    },
});
